import React from "react"
import Skeleton from "react-loading-skeleton"
import DynamicSkeleton from "../../components/DynamicSkeleton"

const columnConfig = {
  "SN Number": {
    content: <Skeleton height="20px" width="80px" />,
    center: true,
  },
  "Charger Details": {
    content: <Skeleton height="80px" width="140px" />,
    center: false,
  },
  Connectors: {
    content: (
      <div className="d-flex justify-content-center gap-2">
        <Skeleton height="60px" width="60px" />
        <Skeleton height="60px" width="60px" />
      </div>
    ),
    center: true,
  },
  "Output Voltage": {
    content: <Skeleton height="20px" width="80px" />,
    center: true,
  },
  "Output Current": {
    content: <Skeleton height="20px" width="80px" />,
    center: true,
  },
  Status: { content: <Skeleton height="20px" width="30px" />, center: true },
  Action: {
    content: (
      <div className="d-flex justify-content-center gap-2">
        <Skeleton height="30px" width="30px" />
        <Skeleton height="30px" width="30px" />
      </div>
    ),
    center: true,
  },
}

const ChargerListSkeleton = ({ infiniteScroll, rows = 6 }) => {
  return (
    <DynamicSkeleton
      rows={rows}
      columnConfig={columnConfig}
      infiniteScroll={infiniteScroll}
    />
  )
}

export default ChargerListSkeleton
